import { ReactElement } from 'react';

import { ButtonProps, IconProps } from '@rbilabs/universal-components';
import type { ActionButtonGradientConfig } from 'features/app-takeover/types';
import { GestureResponderEvent } from 'react-native';

import { CustomEventNames, EventTypes } from 'state/amplitude';
import { HapticsImpactStyle } from 'utils/haptic';

export enum ActionButtonVariants {
  PRIMARY,
  PRIMARY_TAKEOVER,
  OUTLINE,
  INVERSE,
  BOX_SHADOW_INVERSE,
  BOX_SHADOW_PRIMARY,
  TEXT_ONLY,
  OUTLINE_V2,
}

export enum ActionButtonSizes {
  SMALL = 'small',
  LARGE = 'large',
}

type AttributesMap = { [key: string]: string | number | null };

export type IconElementProp = ReactElement<IconProps>;

export interface IActionButtonProps
  extends Omit<
    ButtonProps,
    'onPress' | 'variant' | 'size' | 'rightIcon' | 'leftIcon' | 'startIcon' | 'endIcon'
  > {
  eventAttributes?: AttributesMap;
  size?: ActionButtonSizes;
  eventName?: CustomEventNames;
  eventType?: EventTypes;
  onPress?: (ev: GestureResponderEvent) => void;
  onNonVisualPress?: (ev: GestureResponderEvent) => void;
  skipLogEvent?: boolean;
  isLoading?: boolean;
  noLogOnLongLoading?: boolean;
  testID?: string;
  to?: string;
  linkPath?: string;
  perceptible?: boolean;
  hapticFeedbackStyle?: HapticsImpactStyle;
  variant?: ActionButtonVariants;
  fullWidth?: boolean;
  leftIcon?: IconElementProp;
  rightIcon?: IconElementProp;
  startIcon?: IconElementProp;
  endIcon?: IconElementProp;
  keepIconSize?: boolean;
  gradient?: ActionButtonGradientConfig;
}

export interface IActionLinkProps extends IActionButtonProps {
  to: string;
}
